const button = document.querySelector('.menu-toggle');
button === null || button === void 0 ? void 0 : button.addEventListener('click', () => {
    const isOpen = button.classList.toggle('is-active');
    button.ariaExpanded = isOpen ? 'true' : 'false';
    document.body.dataset.navUi = isOpen ? 'mobile-nav' : 'initial';
    if (isOpen) {
        for (const searchButton of document.querySelectorAll('.toggle-search')) {
            searchButton.ariaExpanded = 'false';
        }
    }
});
export {};
